import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover } from 'react-bootstrap';

const propTypes = {
    id: PropTypes.string.isRequired,
    children: PropTypes.node, // trigger elements
    className: PropTypes.string,
    toolTipContent: PropTypes.node,
    placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
    tooltipTitle: PropTypes.string,
    trigger: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    delay: PropTypes.number,
    disabled: PropTypes.bool,
    'aria-label': PropTypes.string,
    'aria-labelledby': PropTypes.string,
    title: PropTypes.string
};

const defaultProps = {
    children: null,
    className: '',
    toolTipContent: null,
    placement: 'top',
    tooltipTitle: '',
    trigger: ['hover', 'focus'],
    delay: 100,
    disabled: false,
    'aria-label': 'Help',
    title: ''
};

class TooltipWrapper extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            expanded: false
        };
    }

    onToggleTooltip=(showing)=>{
        this.setState({expanded: showing});
    }

    render() {
        let trig = this.props.trigger;
        if (this.props.disabled) {
            trig = [];
        }

        return (
            <OverlayTrigger
                delay={this.props.delay}
                trigger={trig}
                placement={this.props.placement}
                onToggle={this.onToggleTooltip}
                rootClose
                overlay={
                    <Popover
                        id={this.props.id}
                        title={this.props.tooltipTitle}
                        content
                    >
                        {this.props.toolTipContent}
                    </Popover>
                }
            >
                {this.props['aria-labelledby'] ?
                    <span role="button" tabIndex="0" className={`bare-text-button inline-block ${this.props.className}`} aria-labelledby={this.props['aria-labelledby']} title={this.props.title} aria-controls={this.props.id} aria-expanded={this.state.expanded}>
                        {this.props.children}
                    </span>
                    : <span role="button" tabIndex="0" className={`bare-text-button inline-block ${this.props.className}`} aria-label={this.props['aria-label']} title={this.props.title} aria-controls={this.props.id} aria-expanded={this.state.expanded}>
                        {this.props.children}
                    </span>}
            </OverlayTrigger>
        );
    }
}

TooltipWrapper.propTypes = propTypes;
TooltipWrapper.defaultProps = defaultProps;

export default TooltipWrapper;